import { Link, LinkButton, type LinkButtonProps, type LinkProps } from "./Link";
import { Icon } from "../icon/Icon";
import { IconType } from "../icon/IconType";
import { isChrome, isEdge } from "../../../utils/browserChecks";
import { forwardRef } from "react";

export const DownloadUrlLink = forwardRef<HTMLAnchorElement, Omit<LinkProps, "iconBefore">>((props, ref) => (
  <Link ref={ref} iconBefore={<Icon type={IconType.Download} />} {...props} />
));

export const DownloadClickLink = forwardRef<HTMLButtonElement, Omit<LinkButtonProps, "iconBefore">>((props, ref) => (
  <LinkButton ref={ref} iconBefore={<Icon type={IconType.Download} />} {...props} />
));

const skipDownloadParam = isChrome() || isEdge();
export const getDownloadProperty = (filename: string) => (skipDownloadParam ? undefined : filename);
